import { render } from "./errorsTable.vue?vue&type=template&id=3d17890d&ts=true"
import script from "./errorsTable.vue?vue&type=script&lang=ts"
export * from "./errorsTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__